
                import { Component } from "/app/packages/open-source/blognami/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/open-source/blognami/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/open-source/@blognami/main/lib/views/_sidebar/_section.js";
                const hash = "7sj7obW6ai";
                Component.include(createDecoratorsInclude(hash, decorators));
            